import * as _ from 'lodash'
import {WB_ProductGroupRow} from '../PA.Core/PAdbSchemaRows'
import {IHaveProductGroups} from '../PA.Core/PA.Core.IF.Aspects'
import {ASync} from "../PA.Core/Basic/ASync";
import {BehaviorSubject} from "rxjs/BehaviorSubject";

export interface ProductGroupBagOptions {
  AllProductGroups?: WB_ProductGroupRow[],
  InitialProductGroups?: WB_ProductGroupRow[],
  ReadOnlyProductGroups?: WB_ProductGroupRow[],
  bReadOnly?: boolean
}

const ProductGroupBagOptions_default : ProductGroupBagOptions = {
  AllProductGroups: [],
  InitialProductGroups: [],
  ReadOnlyProductGroups: [],
  bReadOnly: false
}


export class ProductGroupBag implements IHaveProductGroups {

  _options: ProductGroupBagOptions
  _bIHaveProductGroupsReadOnly: boolean
  _dctProductGroupsSelectedById: {[id: number]: boolean};
  _dctProductGroupsReadOnlyById: {[id: number]: boolean}
  _ProductGroupsChanged: BehaviorSubject<IHaveProductGroups>;
  _AllProductGroups: WB_ProductGroupRow[];

  constructor(opts: ProductGroupBagOptions) {

    this._options = {}
    _.defaults(this._options, opts || {}, ProductGroupBagOptions_default)

    this._bIHaveProductGroupsReadOnly = this._options.bReadOnly
    this._dctProductGroupsSelectedById = {}
    this._dctProductGroupsReadOnlyById = {}
    this._ProductGroupsChanged =  new BehaviorSubject<IHaveProductGroups>(this)
    this._AllProductGroups = this._options.AllProductGroups

    if(_.isArray(this._options.InitialProductGroups)) {
      _.forEach(this._options.InitialProductGroups, (drWBPG: WB_ProductGroupRow) => {
        if(_.isEmpty(drWBPG)) {
          return
        }
        this._dctProductGroupsSelectedById[drWBPG.cif.WB_PRDGRP_ID] = true
      })
    }

    if(_.isArray(this._options.ReadOnlyProductGroups)) {
      _.forEach(this._options.ReadOnlyProductGroups, (drWBPG: WB_ProductGroupRow) => {
        if(_.isEmpty(drWBPG)) {
          return
        }
        this._dctProductGroupsReadOnlyById[drWBPG.cif.WB_PRDGRP_ID] = true
      })
    }

  }


  get bIHaveProductGroupsLoaded(): boolean { return true }

  get OnIHaveProductGroupsLoaded(): Promise<IHaveProductGroups> {
    return ASync.resolve(this)
  }

  isProductGroupEditable(ProductGroupId: number): boolean {
    return true;
  }

  get ProductGroupsReadOnly(): boolean {
    return this._bIHaveProductGroupsReadOnly
  }

  get ProductGroups(): WB_ProductGroupRow[] {
       let returnValue: WB_ProductGroupRow[] = []
      _.forEach(this.AllProductGroups, (aWBPrdGrp: WB_ProductGroupRow) => {
        if (_.isEmpty(aWBPrdGrp)) {
          return
        }

        if(this.hasProductGroup(aWBPrdGrp.cif.WB_PRDGRP_ID)){
          returnValue.push(aWBPrdGrp)
        }
      })

    return returnValue
  }

  get ProductGroupsChanged(): BehaviorSubject<IHaveProductGroups> { return this._ProductGroupsChanged }

  get AllProductGroups(): WB_ProductGroupRow[] { return this._AllProductGroups }

  addProductGroup(ProductGroupId: number): Promise<void> {

    if (this._dctProductGroupsReadOnlyById[ProductGroupId]) {
      this.notify()
      return
    }

    this._dctProductGroupsSelectedById[ProductGroupId] = true
    this.notify()
    return ASync.resolve(undefined);
  }

  removeProductGroup(ProductGroupId: number): Promise<void> {

    if (this._dctProductGroupsReadOnlyById[ProductGroupId]) {
      this.notify()
      return ASync.resolve()
    }

    this._dctProductGroupsSelectedById[ProductGroupId] = false
    this.notify()

    return ASync.resolve()
  }

  hasProductGroup(ProductGroupId: number): boolean {
    if (!(ProductGroupId in this._dctProductGroupsSelectedById)) {
      return false
    }

    return this._dctProductGroupsSelectedById[ProductGroupId]
  }

  private notify() {
    this._ProductGroupsChanged.next(this)
  }

}
